<h3 class="text-capitalize" mat-dialog-title>{{title}}</h3>

<mat-dialog-content class="small-content">
    <p> Custom fields will appear on each {{data.type}} record and can be exported via the custom report under the
        reports tab.</p>

    <label for="newFieldName">Field Name</label>
    <input [(ngModel)]="newFieldName"
           class="form-control"
           id="newFieldName" name="newFieldName" type="text"/>
</mat-dialog-content>

<mat-dialog-actions>
    <span (click)="close()" class="btn btn-outline-secondary">
        Cancel
    </span>
    <span (click)="onSubmit()" class="btn btn-primary">Save</span>
</mat-dialog-actions>
